(function (){
    'use strict';

    angular
        .module('social', [
            'ui.router',
            'ui.bootstrap',
            'ngSanitize',
            'ngAnimate',
            'ui.footable',
            'validation'
        ]);
})();